import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { Settings } from "react-slick";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";

/** Prev arrow */
function CustomPrevArrow({ onClick, disabled }: { onClick?: () => void; disabled?: boolean }) {
    return (
        <Box
            onClick={!disabled ? onClick : undefined}
            className={`custom-slick-button-prev ${disabled ? "disabled" : ""}`}
            sx={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? 'default' : 'pointer' }}
        >
            <ArrowBackIosNewOutlinedIcon />
        </Box>
    );
}

/** Next arrow */
function CustomNextArrow({ onClick, disabled }: { onClick?: () => void; disabled?: boolean }) {
    return (
        <Box
            onClick={!disabled ? onClick : undefined}
            className={`custom-slick-button-next ${disabled ? "disabled" : ""}`}
            sx={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? 'default' : 'pointer' }}
        >
            <ArrowForwardIosOutlinedIcon />
        </Box>
    );
}

interface SlickSettingsProps {
    cardCount?: number;
    initialSlide?: number;
    loading?: boolean;
    totalCount?: number;
    activeSlide?: number; 
    setActiveSlide?: (slide: number) => void;
}

export const getSlickSettings = ({
    cardCount = 0,
    initialSlide = 0,
    activeSlide = 0, 
    setActiveSlide,  
    loading = false,
    totalCount
}: SlickSettingsProps): Settings => {
    // const [activeSlide, setActiveSlide] = useState(initialSlide);  
    // useEffect(() => {
    //     console.log("before")
    //     setActiveSlide(initialSlide);
    //     console.log("called")
    // }, [initialSlide]);
    const effectiveCardCount = totalCount || cardCount;
    const isSingleCard = effectiveCardCount <= 1;
    const isFirstSlide = activeSlide === 0;
    const isLastSlide = activeSlide === effectiveCardCount - 1;

    return {
        className: "center",
        centerMode: true,
        infinite: !!loading,
        centerPadding: "0px",
        slidesToShow: 1,
        variableWidth: !isSingleCard,
        initialSlide: initialSlide,
        speed: 500,
        cssEase: "ease-in-out",
        prevArrow: <CustomPrevArrow disabled={isFirstSlide} />,
        nextArrow: <CustomNextArrow disabled={isLastSlide} />,
        beforeChange: (current, next) => {
            setActiveSlide && setActiveSlide(next);
        },
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    variableWidth: true,
                    centerPadding: "0px",
                },
            },
            {
                breakpoint: 600,
                settings: {
                    variableWidth: false,
                    centerPadding: "10%",
                    slidesToShow: 1,
                },
            },
        ],
    };
};
